<template>
  <vs-popup class="add-new-incoterms" id="popup" :title="`MANAGE CCP ITEM FIELDS - ${form.name}`" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="manage-ccp-item-fields-popup" @submit.prevent="handleSubmit(onClickUpdateFields)" autocomplete="off">

          <vx-card cardBorder noShadow v-for="(field, indextr) in fields" :key="indextr" class="mb-3">

            <div class="mb-3 vx-row flex">
              <vs-button @click.stop="onClickRemoveField(indextr)" size="small" color="danger"
                class="float-right ml-auto mr-0" icon-pack="feather" icon="icon-x">Remove Field</vs-button>
            </div>

            <div class="mb-3 vx-row">
              <div class="w-full vx-col md:w-1/2 md:mb-0">
                <ValidationProvider :vid="`${indextr}_type`" :name="`${indextr}_type`" rules="required"
                  v-slot="{ errors }">
                  <small class="label">Field Type</small>
                  <v-select :clearable="false" placeholder="" v-model="field.type" :options="field_types"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" label="label" :reduce="option => option.value">
                  </v-select>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="w-full vx-col md:w-1/2 md:mb-0">
                <ValidationProvider :vid="`${indextr}_is_required`" :name="`${indextr}_is_required`" rules=""
                  v-slot="{ errors }">
                  <small class="label">Compulsory Field?</small>
                  <YesNoToggle v-model="field.is_required" />
                </ValidationProvider>
              </div>
            </div>
            <div class="mb-3 vx-row">
              <div class="w-full vx-col md:w-full md:mb-0">
                <ValidationProvider :vid="`${indextr}_label`" :name="`${indextr}_label`" rules="required"
                  v-slot="{ errors }">
                  <small class="label">Field Label</small>
                  <vs-input v-model="field.label" :name="`${indextr}_label`" class="w-full" label=""
                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
            </div>
            <div class="mb-3 vx-row">
              <div class="w-full vx-col md:w-full md:mb-0">
                <ValidationProvider :vid="`${indextr}_description`" :name="`${indextr}_description`" rules=""
                  v-slot="{ errors }">
                  <small class="label">Description</small>
                  <vs-input v-model="field.description" :name="`${indextr}_description`" class="w-full" label=""
                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
            </div>
            <div class="mb-3 vx-row" v-if="field.type === 'Drop Down'">
              <div class="w-full vx-col md:w-full md:mb-0">
                <small class="label">Pick List Options</small>
                <div class="vx-row mb-2" v-for="(option, option_index) in field.options.labels"
                  :key="`${indextr}_${option_index}_option`">
                  <div class="vx-col w-4/5">
                    <ValidationProvider :vid="`${indextr}_${option_index}_label`"
                      :name="`${indextr}_${option_index}_label`" rules="required" v-slot="{ errors }">
                      <vs-input v-model="field.options.labels[option_index]" :name="`${indextr}_${option_index}_label`"
                        class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                        val-icon-pack="feather" />
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-1/5">
                    <vs-button @click.stop="onClickRemoveDropDownOption(indextr, option_index)" size="small"
                      type="border" color="danger" icon-pack="feather" icon="icon-trash-2" class="mt-2"></vs-button>
                  </div>
                </div>
                <vs-button @click.stop="onClickAddDropDownOption(indextr)" size="small" color="success" type="border"
                  icon-pack="feather" icon="icon-plus" class="mt-2">Option</vs-button>
              </div>
            </div>
          </vx-card>

          <div class="mb-3 vx-row">
            <div class="vx-col w-full">
              <span class="flex">
                <vs-button size="small" color="success" icon-pack="feather" icon="icon-plus"
                  class="ml-auto mr-0 float-right" @click.stop="addNewField()">Add Field</vs-button>
              </span>
            </div>
          </div>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button v-can="'edit-ccp-items-setting'" button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <!-- <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button> -->
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CcpRepository = RepositoryFactory.get('ccp');

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import YesNoToggle from "@/components/yes-no-toggle/YesNoToggle.vue"


function initialState() {
  return {
    open: false,
    id: '',
    form: {
      name: ''
    },
    fields: [],
    field_types: [
      { label: 'Yes/No Question', value: 'Boolean' },
      { label: 'Pick List', value: 'Drop Down' },
      { label: 'Text Box', value: 'Text' },
      { label: 'Date Picker', value: 'Date' },
      { label: 'Image/File', value: 'Image' },
    ],
  }
}

export default {
  name: 'ManageCcpItemFieldsPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState());
        this.$refs.form.reset();
        this.open = true;
        this.id = id
        await this.fetchCcpItemDetails()
        await this.fetchCcpItemFiels()
      } catch (error) {

      }
    },
    async fetchCcpItemDetails() {
      await this.$vs.loading({
        container: '#manage-ccp-item-fields-popup',
        scale: 0.45
      })
      try {
        const { data } = (await CcpRepository.getCcp(this.id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#manage-ccp-item-fields-popup > .con-vs-loading')
    },
    async fetchCcpItemFiels() {
      await this.$vs.loading({
        container: '#manage-ccp-item-fields-popup',
        scale: 0.45
      })
      try {
        const { data } = (await CcpRepository.getCcpItemFields(this.id)).data
        this.fields = data
        if (this.fields.length === 0) {
          this.addNewField()
        }
      } catch (error) {
        this.convertAndNotifyError(e)
      } finally {
        this.$vs.loading.close('#manage-ccp-item-fields-popup > .con-vs-loading')
      }
    },
    addNewField() {
      this.fields.push({
        type: 'Boolean',
        label: '',
        description: '',
        options: {
          min: '',
          max: '',
          labels: [
            ''
          ]
        },
        is_required: false
      })
    },
    onClickRemoveField(field_index) {
      this.fields.splice(field_index, 1)
    },
    onClickRemoveDropDownOption(field_index, option_index) {
      this.fields[field_index].options.labels.splice(option_index, 1)
    },
    onClickAddDropDownOption(field_index) {
      this.fields[field_index].options.labels.push('')
    },
    async onClickUpdateFields() {
      const vue = this;
      await this.$vs.loading({
        container: '#manage-ccp-item-fields-popup',
        scale: 0.45
      })
      try {
        let fields_data = this.fields.map((field, index) => {
          let obj = {
            type: field.type,
            label: field.label,
            description: field.description,
            is_required: field.is_required,
            options: {
              min: '',
              max: '',
              labels: field.type === 'Drop Down' ? field.options.labels : []
            },
            id: field.id ? field.id : null,
            order: index + 1
          }
          return obj
        })

        await CcpRepository.updateCcpItemFields(this.id, { fields : fields_data })
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#manage-ccp-item-fields-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#manage-ccp-item-fields-popup > .con-vs-loading')
    },
  },
  components: {
    flatPickr,
    'v-select': vSelect,
    YesNoToggle
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-incoterms>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 50% !important;
}
</style>
